.container {
  font-size: 12px;
  line-height: 15px;
  padding: 3px 6px;

  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 6px;
}

.shortcut {
  color: var(--color-subtle);
}
